import { useState, useEffect, Fragment } from "react";
import { v4 as uuidv4 } from "uuid";
import { ToastContainer, toast } from "react-toastify";

// Images
import logo from './logo.png';
import notFound from "./not-found-icon.png";

import { IoIosCloseCircle } from "react-icons/io";
import { MdOutlineLocalOffer } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import { IoHomeOutline } from "react-icons/io5";
import { IoMdArchive } from "react-icons/io";
import { IoMdTime } from "react-icons/io";
import { MdDeleteOutline } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";
import { IoClose } from "react-icons/io5";

function App() {
  // Tags
  const [tags, setTags] = useState([
    { id: uuidv4(), label: "Exercise" },
    { id: uuidv4(), label: "C++" },
    { id: uuidv4(), label: "Coding" },
  ]);
  const [tagName, setTagName] = useState("");
  const [tagActive, setTagActive] = useState(false);
  const [currentTag, setCurrentTags] = useState("All Notes");

  //Notes
  const [notes, setNotes] = useState([
    {
      id: uuidv4(),
      title: "Test",
      date: new Date("2020-05-12T23:50:21.817Z"),
      tag: [
        { tags: "Exercise", status: true },
        { tags: "Coding", status: true },
      ],
      archive: true,
      content: `Your users should be able to:
                Create, read, update, and delete notes
                Archive notes
                View all their notes
                View all archived notes
                View notes with specific tags`,
    },
    {
      id: uuidv4(),
      title: "React Learning",
      date: new Date(),
      tag: [
        { tags: "Coding", status: true },
        { tags: "C++", status: true },
      ],
      archive: false,
      content: `Learning is the best thing`,
    },
  ]);
  const [shallowNote, setShallowNote] = useState(notes);
  const [noteTitle, setNoteTitle] = useState("");
  const [noteTag, setNoteTag] = useState([]);
  const [noteContent, setNoteContent] = useState("");
  const [noteActive, setNoteActive] = useState(false);
  const [viewNote, setViewNote] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [dropdownHandle, setDropdownHandle] = useState(false);
  const [mobContent, setMobContent] = useState(false)

  const handleSearch = () => {
    if (!searchData) return;
    setShallowNote(
      notes.filter(
        (note) =>
          note.title === searchData ||
          note.tag.find((item) => item.tags === searchData)
      )
    );
  };

  const handleAddTag = () => {
    if (!tagName) return;
    setTags((tags) => [...tags, { id: uuidv4(), label: tagName }]);
    setTagName("");
  };

  const handleChecked = (event) => {
    if (noteTag.find((note) => note.tags === event.target.id)) {
      setNoteTag((noteTag) =>
        noteTag.map((noteTag) =>
          noteTag.tags === event.target.id
            ? { ...noteTag, status: !noteTag.status }
            : noteTag
        )
      );
    } else {
      setNoteTag((noteTag) => [
        ...noteTag,
        { tags: event.target.id, status: true },
      ]);
    }
  };

  // Add Notes
  const handleAddNotes = (e) => {
    e.preventDefault();
    if (!noteTitle || !noteContent) return;
    const updates = [
      ...notes,
      {
        id: uuidv4(),
        title: noteTitle,
        date: new Date(),
        tag: noteTag,
        content: noteContent,
        archive: false,
      },
    ];
    setNotes(updates);
    setShallowNote(updates);
    setNoteActive(false);
    toast.success("Notes Added Successfully!");
    setNoteTitle("");
    setNoteContent("");
    setNoteTag([]);
  };
  // Tag Handler
  const handleCurrentTags = (title) => {
    setCurrentTags(title);
    if (title === "All Notes") setShallowNote(notes);
    else if (title === "Archives Notes") {
      setShallowNote(notes.filter((note) => note.archive === true));
    } else {
      setShallowNote(
        notes.filter((note) => note.tag.find((n) => n.tags === title))
      );
    }
  };
  // Handle Delete
  const handleNoteDelete = (id) => {
    const confirmed = window.confirm("Are you sure to delete this item");
    if (confirmed) {
      const updates = (notes) => notes.filter((note) => note.id !== id);
      setNotes(updates);
      setShallowNote(updates);
      toast.error("Notes Deleted Successfully!");
    }
  };
  // Set Archive
  const handleArchive = (id) => {
    const updates = notes.map((note) =>
      note.id === id ? { ...note, archive: !note.archive } : note
    );
    setNotes(updates);
    setShallowNote(updates);
  };
  // Set Date
  const dateManage = (now) => {
    let monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let currentMonth = now.getMonth();
    let date = now.getDate();
    let year = now.getFullYear();
    let month = monthNames[currentMonth];
    const dateFormat = `${month.slice(0, 3)}, ${date}, ${year}`;
    return dateFormat;
  };

  useEffect(() => { }, []);

  return (
    <div className="note-taking">
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      <ToastContainer />
      {/* Left Side */}
      <div className="left-menu">
        <div className="head-logo">
          <img src={logo} alt="" className="logo" />
        </div>

        <div className="mob-show header-control">
          <ul className="header-menu">
            <li
              className={`${currentTag === "All Notes" ? "activeTag" : ""}`}
              onClick={() => handleCurrentTags("All Notes")}
            >
              <IoHomeOutline size="20" />
              All Notes
            </li>
            <li
              className={`${currentTag === "Archives Notes" ? "activeTag" : ""
                }`}
              onClick={() => handleCurrentTags("Archives Notes")}
            >
              <IoMdArchive size="20" />
              Archives Notes
            </li>
          </ul>
          <ul className="handle-dropdown">
            <li onClick={() => setDropdownHandle((item) => !item)}>
              Tags
              <IoIosArrowDown
                size="20"
                className={`${dropdownHandle && "rotate-arrow"}`}
              />
            </li>
            {dropdownHandle && (
              <ul className="sub-dropdown">
                {tags.map((tag) => (
                  <li
                    key={tag.id}
                    onClick={() => handleCurrentTags(tag.label)}
                    className={`${currentTag === tag.label ? "activeTag" : ""}`}
                  >
                    <MdOutlineLocalOffer size="20" />
                    {tag.label}
                  </li>
                ))}
              </ul>
            )}
          </ul>
          <div className="tag-title">
            <button onClick={() => setTagActive(true)}>Add Tags</button>
          </div>
        </div>
        <div className="web-show">
          <ul>
            <li
              className={`${currentTag === "All Notes" ? "activeTag" : ""}`}
              onClick={() => handleCurrentTags("All Notes")}
            >
              <IoHomeOutline size="20" />
              All Notes
            </li>
            <li
              className={`${currentTag === "Archives Notes" ? "activeTag" : ""
                }`}
              onClick={() => handleCurrentTags("Archives Notes")}
            >
              <IoMdArchive size="20" />
              Archives Notes
            </li>
          </ul>
          <div className="tag-title">
            <h3>Tags</h3>
            <button onClick={() => setTagActive(true)}>Add Tags</button>
          </div>
          <ul>
            {tags.map((tag) => (
              <li
                key={tag.id}
                onClick={() => handleCurrentTags(tag.label)}
                className={`${currentTag === tag.label ? "activeTag" : ""}`}
              >
                <MdOutlineLocalOffer size="20" />
                {tag.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mob-show main-title">
        <h1>{currentTag}</h1>
        <div className="search-box mob-show">
          <input
            type="text"
            placeholder="Search by Title or Tag"
            value={searchData}
            onChange={(e) => setSearchData(e.target.value)}
          />
          <IoIosSearch
            size="15"
            className="search-icon"
            onClick={handleSearch}
          />
        </div>
      </div>
      {/* Right Side */}
      <div className="right-content">
        <div className="notes-header web-show">
          <h1>{currentTag}</h1>
          <div className="search-box ">
            <input
              type="text"
              placeholder="Search by Title or Tag"
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
            />
            <IoIosSearch
              size="15"
              className="search-icon"
              onClick={handleSearch}
            />
          </div>
        </div>
        <div className="notes-details">
          <div className="notes-list">
            <button onClick={() => setNoteActive(true)}>
              Create New Notes
            </button>
            <>
              {shallowNote.length ? (
                shallowNote.map((note) => (
                  <div
                    className={`note-box ${viewNote === note.id && "selected-note"
                      }`}
                    key={note.id}
                    onClick={() => (setViewNote(note.id), setMobContent(true))}
                  >
                    <h4>{dateManage(note.date)}</h4>
                    <h2>{note.title}</h2>
                    <p>{note.content}</p>
                    <p>
                      {note.tag.map((item, i) => (
                        <Fragment key={i}>
                          {item.status && (
                            <span className="tag-design">{item.tags}</span>
                          )}
                        </Fragment>
                      ))}
                    </p>
                  </div>
                ))
              ) : (
                <div className="empty-notes">
                  <img src={notFound} alt="" className="not-found-icon" />
                  <p>No Notes Found!</p>
                </div>
              )}
            </>
          </div>
          {shallowNote.length > 0 && (
            <div className={`notes-content ${mobContent && "note-show"}`}>
              {shallowNote.map((note) => (
                <Fragment key={note.id}>
                  {note.id === viewNote && (
                    <>
                      <div className="selected-notes">
                        <span className="mob-show close-btn" onClick={() => setMobContent(false)}><IoClose /></span>
                        <div className="separate-section">
                          <div className="note-title-handle">
                            <h2>{note.title}</h2>
                            {note.archive && <IoMdArchive size="22" />}
                          </div>
                          <div className="mob-show note-handle">
                            <button onClick={() => handleArchive(note.id)}>
                              <IoMdArchive size="20" className="delete-icon" />
                              Archive Note
                            </button>
                            <button onClick={() => handleNoteDelete(note.id)}>
                              <MdDeleteOutline size="20" /> Delete Note
                            </button>
                          </div>
                          <div className="note-tags">
                            <span>
                              <MdOutlineLocalOffer size="20" />
                              Tags:
                            </span>
                            <div className="tag-list">
                              {note.tag.map((item, i) => (
                                <Fragment key={i}>
                                  {item.status && <span>{item.tags}</span>}
                                </Fragment>
                              ))}
                            </div>
                          </div>
                          <div className="note-tags">
                            <span>
                              <IoMdTime size="20" />
                              Last Edited:
                            </span>
                            {dateManage(note.date)}
                          </div>
                        </div>
                        <p>{note.content}</p>
                      </div>
                      <div className="web-show note-handle">
                        <button onClick={() => handleArchive(note.id)}>
                          <IoMdArchive size="20" className="delete-icon" />
                          Archive Note
                        </button>
                        <button onClick={() => handleNoteDelete(note.id)}>
                          <MdDeleteOutline size="20" /> Delete Note
                        </button>
                      </div>
                    </>
                  )}
                </Fragment>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* Tag Modal */}
      {tagActive && (
        <div className="tag-modal">
          <div className="add-tags">
            <IoIosCloseCircle
              size="30px"
              className="close-tag-btn"
              onClick={() => setTagActive(false)}
            />
            <h3>Add Tag</h3>
            <label>Enter Tag Name</label>
            <input
              type="text"
              value={tagName}
              onChange={(e) => setTagName(e.target.value)}
              placeholder="e.g. holiday, finance..."
            />
            <button onClick={handleAddTag}>Submit</button>
          </div>
        </div>
      )}
      {/* Note Modal */}
      {noteActive && (
        <div className="tag-modal">
          <div className="add-tags">
            <form onSubmit={handleAddNotes}>
              <IoIosCloseCircle
                size="30px"
                className="close-tag-btn"
                onClick={() => setNoteActive(false)}
              />
              <h3>Create Notes</h3>
              <label>Title</label>
              <input
                type="text"
                value={noteTitle}
                placeholder="Enter title"
                onChange={(e) => setNoteTitle(e.target.value)}
              />
              {tags.length > 0 && <label>Select Tags</label>}
              {tags.map((tag) => (
                <div key={tag.id} className="tag-select">
                  <input
                    type="checkbox"
                    id={tag.label}
                    value={tag.label}
                    onChange={handleChecked}
                    defaultChecked={false}
                  />
                  <label htmlFor={tag.label}>{tag.label}</label>
                </div>
              ))}
              <label>Enter Notes</label>
              <textarea
                placeholder="Enter notes"
                value={noteContent}
                onChange={(e) => setNoteContent(e.target.value)}
              >
                Enter notes
              </textarea>
              <button>Create Notes</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
